import { render } from "./receipts.vue?vue&type=template&id=30a4d08a"
import script from "./receipts.vue?vue&type=script&lang=js"
export * from "./receipts.vue?vue&type=script&lang=js"

import "./receipts.vue?vue&type=style&index=0&id=30a4d08a&lang=sass"
script.render = render

export default script